import { LoginResponse } from '@/interfaces/login-response.interface';
import { AddOrRemove, FetchCache } from '@/utils/local-storage-cache.util';
import { ActionContext, createStore, Store } from 'vuex';

export interface LoginVuex {
    account: LoginResponse | undefined;
}
const LS_ACCOUNT_KEY = 'account';
const cache = (store: Store<LoginVuex>) => {
    store.subscribe((mutation, state: LoginVuex) => {
        switch (mutation.type) {
            case 'setAccount':
                AddOrRemove(LS_ACCOUNT_KEY, state.account);
                break;
            default: break;
        }
    });
};

export const LoginStore: Store<LoginVuex> = createStore({
    state: {
        account: FetchCache(LS_ACCOUNT_KEY)
    },
    mutations: {
        setAccount(state: LoginVuex, account: LoginResponse | undefined) {
            state.account = account;
        },
    },
    actions: {
        updateToken(context: ActionContext<LoginVuex, LoginVuex>, account: LoginResponse) {
            account.tokenTimestamp = new Date().getTime();
            context.commit('setAccount', account);
        },
        async logout(context: ActionContext<LoginVuex, LoginVuex>) {
            context.commit('setAccount');
            const saveThisForCurrentDevice = localStorage.getItem('acceptedtc');
            localStorage.clear();
            if (saveThisForCurrentDevice) {
                localStorage.setItem('acceptedtc', saveThisForCurrentDevice);
            }
        }
    },
    getters: {
        Token: (state: LoginVuex) => (): string | undefined => {
            return state.account?.token;
        },
        TokenTimestamp: (state: LoginVuex) => (): number | undefined => {
            return state.account?.tokenTimestamp;
        },
        Name: (state: LoginVuex) => (): string | undefined => {
            return `${state.account?.user.name} ${state.account?.user.surname}`;
        },
        Role: (state: LoginVuex) => (): string | undefined => {
            return state.account?.role;
        },
        Status: (state: LoginVuex) => (): string | undefined => {
            return state.account?.user.status;
        },
        Id: (state: LoginVuex) => (): number | undefined => {
            return state.account?.user.id;
        },
    },
    plugins: [cache]
});
